import { render, staticRenderFns } from "./DsAppForm.vue?vue&type=template&id=4ce1ef4a&scoped=true&"
import script from "./DsAppForm.vue?vue&type=script&lang=js&"
export * from "./DsAppForm.vue?vue&type=script&lang=js&"
import style0 from "./DsAppForm.vue?vue&type=style&index=0&id=4ce1ef4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce1ef4a",
  null
  
)

export default component.exports